import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

var menuRouters = [];//定义子路由
const appRouterFiles = require.context('@/router/menu', true, /\.js$/)
appRouterFiles.keys().map((item, index,data, arr=[]) => {
    const value = appRouterFiles(item).default
    menuRouters = menuRouters.concat(value)
})

export const constantRoutes = [
    {
        path: '/',
        component: () => import('@/views/login'),
        redirect: '/login',
    },
    {
        path: '/login',
        component: () => import('@/views/login'),
        hidden: false
    },
    {
        path: '/home',
        component: () => import('@/views/home/index'),
        redirect: '/main',
        meta: { title: '主页' },
        children: [
            {
                path: '/main',
                component: () => import('@/views/home/main/index'),
                meta: { title: '首页' },
            },
            ...menuRouters
        ]
    },
]

const createRouter = () => new Router({
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // 重置路由器
}

export default router
